import { katTranslator } from '../../shared/i18n';

const strings = {
  kat_skip_link: {
    'en-US': 'Skip to content (press enter)',
    'ar-AE': 'تخطي إلى المحتوى (اضغط على مفتاح الإدخال Enter)',
    'bn-IN': 'কন্টেন্টে এগিয়ে যান (এন্টার টিপুন)',
    'de-DE': 'Zum Inhalt wechseln (drücken Sie die Eingabetaste)',
    'en-IN': 'Skip to content (press Enter)',
    'es-ES': 'Ir al contenido (pulsa "Intro")',
    'es-MX': 'Continuar al contenido (haz clic en Intro)',
    'fr-BE': 'Passer au contenu (appuyez sur la touche Entrée)',
    'fr-FR': 'Passer au contenu (appuyez sur Entrée)',
    'gu-IN': 'કન્ટેન્ટ પર જાઓ (એન્ટર દબાવો)',
    'hi-IN': 'कटेंट पर जाएं (एंटर बटन दबाएं)',
    'it-IT': 'Passa al contenuto (premi Invio)',
    'ja-JP': 'コンテンツにスキップ（enterを押す）',
    'kn-IN': 'ವಿಷಯಕ್ಕೆ ತೆರಳಿ (ಎಂಟರ್ ಒತ್ತಿರಿ)',
    'ko-KR': '콘텐츠로 건너뛰기(Enter 키 누르기)',
    'ml-IN': 'ഉള്ളടക്കത്തിലേക്ക് പോകുക (എൻ്റർ അമർത്തുക)',
    'mr-IN': 'सामग्रीवर जा (एंटर दाबा)',
    'nl-BE': 'Overslaan naar inhoud (druk op enter)',
    'nl-NL': 'Meteen doorgaan naar inhoud (druk op enter)',
    'pl-PL': 'Pomiń i przejdź do treści (naciśnij Enter)',
    'pt-BR': 'Ir para o conteúdo (pressione Enter)',
    'pt-PT': 'Saltar para conteúdo (prima Enter)',
    'sv-SE': 'Hoppa till innehållet (tryck på retur)',
    'ta-IN': 'உள்ளடக்கத்திற்குச் செல்க (என்டரை அழுத்தவும்)',
    'te-IN': 'కంటెంట్‌కి దాటవేయి (ఎంటర్ నొక్కండి)',
    'th-TH': 'ข้ามไปยังเนื้อหา (กด Enter)',
    'tr-TR': 'İçeriğe geç (enter tuşuna basın)',
    'vi-VN': 'Chuyển đến nội dung (nhấn enter)',
    'zh-CN': '跳转至内容（按回车键）',
    'zh-TW': '略過內容 (按 Enter 鍵)',
  },
  kat_toggle_nav: {
    'en-US': 'Toggle Navigation',
    'ar-AE': 'تبديل التنقل',
    'bn-IN': 'নেভিগেশন টগল করুন',
    'de-DE': 'Navigation wechseln',
    'en-IN': 'Toggle Navigation',
    'es-ES': 'Alternar navegación',
    'es-MX': 'Desplazar navegación',
    'fr-BE': 'Basculer la navigation',
    'fr-FR': 'Basculer la navigation',
    'gu-IN': 'ટૉગલ નેવિગેશન',
    'hi-IN': 'नेविगेशन टॉगल करें',
    'it-IT': 'Attiva/disattiva navigazione',
    'ja-JP': 'ナビゲーションの切り替え',
    'kn-IN': 'ಟಾಗಲ್ ನ್ಯಾವಿಗೇಷನ್',
    'ko-KR': '탐색 토글',
    'ml-IN': 'നാവിഗേഷൻ ടോഗിൾ ചെയ്യുക',
    'mr-IN': 'नॅव्हिगेशन टॉगल करा',
    'nl-BE': 'Toggle-navigatie',
    'nl-NL': 'Toggle navigatie',
    'pl-PL': 'Przełącz nawigację',
    'pt-BR': 'Alternar navegação',
    'pt-PT': 'Alternar a navegação',
    'sv-SE': 'Växla navigering',
    'ta-IN': 'வழிசெலுத்தலை மாற்று',
    'te-IN': 'నావిగేషన్‌ని టోగుల్ చేయండి',
    'th-TH': 'ไม่ต้องสลับช่องทาง',
    'tr-TR': 'Gezinmeyi Aç/Kapat',
    'vi-VN': 'Chuyển đổi điều hướng',
    'zh-CN': '切换导航',
    'zh-TW': '切換導覽',
  },
};

export default katTranslator(strings);
